export {useIntersection} from './useIntersection';
export type {UseIntersectionProps} from './useIntersection';
